import React from "react";
import { HeaderLinkStyle as Link } from "./BaseLink";
import { Arrow } from "../../BaseComponents/Icons/Svg";

export const HeaderLink = (props) => {
	const { text, arrow, color } = props;
	return (
		<Link {...props}>
			<span>{text}</span>
			{arrow && <Arrow color={color} />}
		</Link>
	);
};
